import React, { useState } from "react";
import CarForm from "./Components/CarForm";
import CarList from "./Components/CarList";
import CarsOld from "./Components/CarsOld";
import Cars from "./Components/Cars";
import ComponentDescription from "./Components/ComponentsDescription";
import LanguageSwitcher from "./Components/LanguageSwitcher";
import { descriptions } from "./i18n/descriptions";

function App() {
  const [carToEdit, setCarToEdit] = useState(null);
  // eslint-disable-next-line
  const [refresh, setRefresh] = useState(false);

  const triggerRefresh = () => {
    setRefresh((prev) => !prev);
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <h1 className="mb-4 text-center text-4xl font-extrabold text-indigo-600">
        Car Management System
      </h1>

      {/* ===== LANGUAGE SWITCHER ===== */}
      <LanguageSwitcher />

      <div className="container mx-auto px-4">
        {/* ===== FORM + LIST ===== */}
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* Car Form */}
          <div className="w-full space-y-4 lg:col-span-1">
            <ComponentDescription title="CarForm" text={descriptions.carForm} />
            <CarForm
              carToEdit={carToEdit}
              setCarToEdit={setCarToEdit}
              refresh={triggerRefresh}
            />
          </div>

          {/* Car List */}
          <div className="w-full space-y-4 lg:col-span-2">
            <ComponentDescription title="Car List" text={descriptions.carList} />
            <CarList setCarToEdit={setCarToEdit} refresh={triggerRefresh} />
          </div>
        </div>

        {/* ===== FILTERS ===== */}
        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* Cars Old */}
          <div className="w-full space-y-4">
            <ComponentDescription title="Cars Old" text={descriptions.carsOld} />
            <CarsOld refresh={triggerRefresh} />
          </div>

          {/* All Cars */}
          <div className="w-full space-y-4">
            <ComponentDescription title="All Cars" text={descriptions.carsAll} />
            <Cars refresh={triggerRefresh} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
